<template>
  <div>
    <el-alert
      title="Usage of this page is not advised and access will be disabled later this year. Please use the new Zones page under Manage > Carrier > Zones."
      type="error"
      show-icon
      class="mb-4"
    />
    <Legacy
      view="tools"
      action="zones"
    />
  </div>
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Zones',
      breadcrumb: {
        name: 'Zones',
        route: { name: 'manage-zones' }
      }
    }
  }
}
</script>
